// We have to define all the type of meshes, geometries, materials, and helpers here
export const ShapeType = {
    Mesh: "Mesh",
    LineSegments: "LineSegments",
    Scene: "Scene",
    Geometry: {
        BoxGeometry: "BoxGeometry",
        EdgesGeometry: "EdgesGeometry",
        SphereGeometry: "SphereGeometry",
        CircleGeometry: "CircleGeometry",
        ConeGeometry: "ConeGeometry",
        CylinderGeometry: "CylinderGeometry",
        ExtrudeGeometry: "ExtrudeGeometry",
        PlaneGeometry: "PlaneGeometry",
        BufferGeometry: "BufferGeometry",
    },
    Material: {
        MeshBasicMaterial: "MeshBasicMaterial",
        MeshStandardMaterial: "MeshStandardMaterial",
    },
};

export enum MeshType {
    Cube = "Cube",
    // Cuboid = "Cuboid",
    CurvedCube = "CurvedCube",
    CurvedCube2 = "CurvedCube2",
    HalfCylinder = "HalfCylinder",
    Prism = "Prism",
    SquarePyramid = "SquarePyramid",
    Cone = "Cone",
    Cylinder = "Cylinder",
    HemiSphere = "HemiSphere",
    RightTriangle = "RightTriangle",
    // ConcavePrism = "ConcavePrism",
}

// objects that support the scene
export enum AuxiliaryObjectType {
    Plane = "Plane",
    Outline = "Outline",
    GridHelper = "GridHelper",
    TransparentCube = "TransparentCube",
    NodeOrHoleMesh = "NodeOrHoleMesh",
}

export enum CurveType {
    EllipseCurve = "EllipseCurve",
    LineCurve = "LineCurve",
}

export interface ShapeCounts {
    [key: string]: number;
}

export interface ShapeData {
    name: string;
    count: number;
}

export interface ShapeInfo {
    filteredShapeArray: ShapeData[];
    totalBlock: number;
}
